export default "__VITE_ASSET__33d17632__"